<template>
  <v-dialog
    :value="show"
    persistent
    max-width="600px"
    @input="onDialogInput"
  >
    <v-card>
      <v-card-title class="d-flex justify-space-between">
        <span>{{ $t('queues.reports.emailDialog.title') }}</span>
        <v-btn icon small @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-text-field
          v-model="emails"
          :label="$t('queues.reports.emailDialog.emailLabel')"
          :hint="$t('queues.reports.emailDialog.emailHint')"
          persistent-hint
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="closeDialog">
          {{ $t('queues.reports.emailDialog.cancel') }}
        </v-btn>
        <v-btn text color="primary" @click="sendReportToEmail" :loading="emailLoading" :disabled="emailLoading || !validEmailForm || !(reportParams && reportParams.report_type)">
          {{ $t('queues.reports.emailDialog.submit') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import API from '@/api'
import events from 'Store/events'

export default {
  name: 'queues-reports-email-dialog',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    reportParams: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      emailLoading: false,
      emails: ''
    }
  },
  computed: {
    validEmailForm () {
      return this.emails && this.emails.split(',').every(email => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim()))
    }
  },
  methods: {
    onDialogInput (value) {
      if (!value) this.closeDialog()
    },
    closeDialog () {
      this.emails = ''
      this.$emit('close')
    },
    sendReportToEmail () {
      this.emailLoading = true
      const emailsArray = this.emails.split(',').map(email => email.trim()).filter(email => email)
      API.postQueueReportEmail({
        ...this.reportParams,
        emails: emailsArray
      }).then((response) => {
        if (response.data?.success) {
          events.pubNotify({
            text: 'queues.reports.emailReportSuccess',
            status: 'success'
          })
          this.closeDialog()
          this.$emit('success')
        }
      }).catch(err => {
        this.dbg(err.response)
        events.pubError({ key: 'queues.reports.emailReportFail' })
      }).finally(() => {
        setTimeout(() => {
          this.emailLoading = false
        }, 5000)
      })
    }
  }
}
</script>
